module.exports = __webpack_public_path__ + "img/about_join_3.af51f222.png";